import {CampaignFeatureType} from '../models'
import {assertArray, assertEnum} from '../utils'
import {AssertTypeFn} from './general'

export const featuresNormaliser: AssertTypeFn<CampaignFeatureType[]> = (arr) =>
  assertArray(arr, (val) => assertEnum(val, CampaignFeatureType))

export const featuresResponseNormaliser = (
  obj: unknown,
): CampaignFeatureType[] => {
  const response = obj as {features: unknown}
  return assertArray(response.features, (val) =>
    assertEnum(val, CampaignFeatureType),
  )
}
